import { render, staticRenderFns } from "./GlobalSection.vue?vue&type=template&id=23669bbf&scoped=true&"
import script from "./GlobalSection.vue?vue&type=script&lang=js&"
export * from "./GlobalSection.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSection.vue?vue&type=style&index=0&id=23669bbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23669bbf",
  null
  
)

export default component.exports